module.exports = __webpack_public_path__ + "static/media/cart.c0484e32.png";